// src/App.js
import React, { Suspense, lazy } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import theme from "./styles/theme";
import GlobalStyles from "./styles/GlobalStyles";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";

import Home from "./routes/Home";

const Products = lazy(() => import("./routes/Products"));
const ProductDetail = lazy(() => import("./routes/ProductDetail"));
const About = lazy(() => import("./routes/About"));
const Contact = lazy(() => import("./routes/Contact"));
const Checkout = lazy(() => import("./routes/Checkout"));
const OrderSuccess = lazy(() => import("./routes/OrderSuccess"));
const NotFound = lazy(() => import("./routes/NotFound"));

const Admin = lazy(() => import("./routes/admin/Admin"));
const AdminLogin = lazy(() => import("./routes/admin/AdminLogin"));

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AuthProvider>
        <CartProvider>
          <ScrollToTop />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/produktet" element={<Products />} />
              <Route path="/produktet/:id" element={<ProductDetail />} />
              <Route path="/rreth-nesh" element={<About />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/porosia" element={<Checkout />} />
              <Route
                path="/porosia/sukses/:orderId"
                element={<OrderSuccess />}
              />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/*" element={<Admin />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
